(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('TestProgressService', TestProgressService)

	/** @ngInject */
	function TestProgressService(HttpService) {
		const TestProgressService = {
			postTestProgress
		};

		return TestProgressService;

		function postTestProgress(progressData) {
			return HttpService.post('/test-progress', progressData);
		}
	}
}());